import { useMemo } from 'react';

export type WaveMode = 'idle' | 'listening' | 'thinking' | 'speaking';

/** Elena's voice line: flat when idle, ivory while you talk, brass while she answers. */
export function Waveform({ mode, height = 44 }: { mode: WaveMode; height?: number }) {
  const bars = useMemo(
    () =>
      Array.from({ length: 38 }, (_, i) => {
        const t = (i / 37 - 0.5) * 2;
        const envelope = Math.exp(-t * t * 2.4);
        return 4 + envelope * (18 + 8 * Math.abs(Math.sin(i * 1.7)));
      }),
    [],
  );

  return (
    <svg
      className={`wave wave-${mode}`}
      viewBox="0 0 400 60"
      preserveAspectRatio="none"
      width="100%"
      height={height}
      role="img"
      aria-label={
        mode === 'listening'
          ? 'Elena sluša'
          : mode === 'speaking'
            ? 'Elena govori'
            : mode === 'thinking'
              ? 'Elena razmišlja'
              : 'Elena je spremna'
      }
    >
      <line x1="0" y1="30" x2="400" y2="30" className="wave-base" />
      {mode === 'idle' ? (
        <circle cx="200" cy="30" r="3.5" className="wave-dot" />
      ) : mode === 'thinking' ? (
        [0, 1, 2, 3, 4].map((i) => (
          <circle
            key={i}
            cx={160 + i * 20}
            cy="30"
            r="3.5"
            className="wave-dot"
            style={{ animationDelay: `${i * 0.12}s` }}
          />
        ))
      ) : (
        bars.map((h, i) => (
          <line
            key={i}
            x1={52 + i * 8}
            x2={52 + i * 8}
            y1={30 - h}
            y2={30 + h}
            className="wave-bar"
            style={{ animationDelay: `${(i % 7) * 0.09}s` }}
          />
        ))
      )}
    </svg>
  );
}
